module.exports = RedNaoPDFImporter.default('PDFImporter/Manager/PDFManager/DocumentManager.Options');